import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@metarouter-private/mr-mui';

export default function RevisionDisabledNote({ playbook }) {
  const { disabledAt, disabledBy, disabledNote } = playbook;
  const disabledOn = new Date(disabledAt).toLocaleDateString();
  const note = disabledNote ? `: "${disabledNote}"` : '';

  return (
    <Typography variant="caption" color="text.secondary" data-test-id="revisionDisabledNote">
      {`Disabled by ${disabledBy?.name ?? 'Unknown'}, ${disabledOn}${note}`}
    </Typography>
  );
}

RevisionDisabledNote.propTypes = {
  playbook: PropTypes.shape({
    disabledAt: PropTypes.string.isRequired,
    disabledBy: PropTypes.shape({ name: PropTypes.string }),
    disabledNote: PropTypes.string,
  }).isRequired,
};
